module.exports = __webpack_public_path__ + "img/dto-home72.3737d70a.png";